import { DeleteIcon, FindItemIcon, PlusIcon } from "../../../assets/icons";
import { TextInput } from "../../../components/textInput/textInput";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Button } from "../../../components/button/button";
import { useOpenPage } from "../../../hooks/useOpenPage";
import { useConfirmPopup } from "../../../components/popup/confirmPopup/confirmPopup";
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate";
import { Spring } from "../../../components/spring/spring";
import { EditableHeader } from "../../../components/editableHeader/editableHeader";
import { UploadFile } from "../../../components/uploadFile/uplodeFile";
import KnowledgeAPI from "../../../api/KnowledgeAPI";

import styles from "./adminKnowledgeBaseTestsPage.module.css";

import { Text } from "../../../components/text/text";

export const AdminKnowledgeBaseTestsPage = () => {
    const { categoryId } = useParams();

    const openPage = useOpenPage();

    const [search, setSearch] = useState("");
    const [materialName, setMaterialName] = useState("");
    const [tests, setTests] = useState([]);

    useEffect(() => {
        if (!categoryId) return;
        KnowledgeAPI
            .fetchAdminTests(categoryId)
            .then(res => {
                setTests(res.tests);
                setMaterialName(res.name);
            })
            .catch(console.error);
    }, [categoryId])

    const [popupParams, setPopupParams] = useState(null);
    const onDeleteTest = () => {
        if (!popupParams) return;

        KnowledgeAPI
            .deleteTest(popupParams)
            .then(() => setTests(prev => prev.filter(el => el.id !== popupParams)))
            .catch(console.error);
    }

    const [Popup, open] = useConfirmPopup(
        "Подтвердите действие",
        "Вы уверены, что хотите удалить тест?",
        onDeleteTest
    );

    const { cafeId } = useParams();
    const navigate = useAnimatedNavigate();
    const onDeleteCategory = () => {
        KnowledgeAPI
            .deleteMaterial(categoryId)
            .then(() => {
                navigate(`/admin/${cafeId}/knowledge`);
            })
            .catch(console.error);
    }

    const [CategoryPopup, openDeleteCategory] = useConfirmPopup(
        "Подвердите действие",
        "Вы уверены, что хотите удалить категорию?",
        onDeleteCategory
    )

    const [materials, setMaterials] = useState([]);
    useEffect(() => {
        KnowledgeAPI
            .fetchEducationMaterials(categoryId)
            .then(setMaterials)
            .catch(console.error);
    }, [categoryId]);

    const [popupMaterialParams, setPopupMaterialParams] = useState(null);
    const onDeleteMaterial = () => {
        KnowledgeAPI
            .deleteEducationMaterial(popupMaterialParams)
            .then(() => setMaterials(prev => prev.filter(el => el.id !== popupMaterialParams)))
            .catch(console.error);
    }

    const [DeleteMaterialPopup, openDeleteMaterial] = useConfirmPopup(
        "Подтвердите действие",
        "Вы уверены, что хотите удалить материал?",
        onDeleteMaterial,
    )

    const [file, setFile] = useState(null);
    const onUpdate = (newName) => {
        KnowledgeAPI
            .updateCategoryName(categoryId, newName)
            .catch(console.error);

        if (file) {
            KnowledgeAPI
                .uploadMaterialIcon(
                    cafeId,
                    categoryId,
                    file
                )
                .catch(console.error);
        }
    }

    return (
        <>
            <EditableHeader title={materialName} onEdit={onUpdate}>
                <UploadFile
                    view="thin"
                    selectedFile={file}
                    setSelectedFile={setFile}
                    placeholder="Выберите новое изображение категории"
                    accept="image/*"
                />
            </EditableHeader>

            <TextInput value={search} setValue={setSearch} leftContent={<FindItemIcon />} />


            <Text as="div" variant="h3" className={styles.block_subtitle} >Материалы</Text>

            <div className={styles.block}>
                {materials.filter(test => test.title.toLowerCase().includes(search.trim().toLowerCase())).map(data =>
                    <Button
                        key={data.id}
                        noActiveAnimation
                        className={styles.test}
                        text={data.title}
                        type="secondary"
                        icon={
                            <DeleteIcon
                                onClick={e => {
                                    e.stopPropagation();
                                    setPopupMaterialParams(data.id);
                                    openDeleteMaterial();
                                }}
                            />
                        }
                        onClick={openPage(`materials/${data.id}`)}
                    />
                )}

                <Button
                    text={
                        <div style={{ display: "flex", gap: "4px", alignItems: "center", justifyContent: "center" }}>
                            <PlusIcon />
                            Добавить материал
                        </div>
                    }
                    view="thin"
                    onClick={openPage(`materials/add`)}
                    type="secondary"
                />
            </div>

            <Text as="div" variant="h3" className={styles.block_subtitle} >Тесты</Text>

            <div className={styles.block}>
                {tests.filter(test => test.name.toLowerCase().includes(search.trim().toLowerCase())).map((test) =>
                    <Button
                        key={test.id}
                        noActiveAnimation
                        className={styles.test}
                        text={test.name}
                        type="secondary"
                        icon={
                            <DeleteIcon
                                onClick={e => {
                                    e.stopPropagation()
                                    setPopupParams(test.id);
                                    open();
                                }}
                            />
                        }
                        onClick={openPage(`tests/${test.id}`)}
                    />
                )}

                <Button
                    text={
                        <div style={{ display: "flex", gap: "4px", alignItems: "center", justifyContent: "center" }}>
                            <PlusIcon />
                            Добавить тест
                        </div>
                    }
                    view="thin"
                    onClick={openPage(`tests/add`)}
                    type="secondary"
                />
            </div>

            <Spring />

            <Button
                text="Удалить категорию"
                type="semi_destructive"
                onClick={openDeleteCategory}
            />

            {Popup}
            {CategoryPopup}
            {DeleteMaterialPopup}
        </>
    )
}
